import React, { useState, useEffect } from "react";
import { putEmpresa as modifEmpresa } from "../helpers/rutaEmpresas";
import { Modal, Button } from "react-bootstrap";
import { getLocalidades } from "../helpers/rutaLocalidades";
import { getRutas } from "../helpers/rutaRutas";
import 'animate.css';

const ModalFormEmpresa = ({ empresa, handleClose, show }) => {
  const [showSuccess, setShowSuccess] = useState(false);
  const [formValues, setFormValues] = useState({
    codemp: "",
    empresa: "",
  });

  useEffect(() => {
    if (empresa && empresa._id) {
      setFormValues({
        codemp: empresa.codemp || "",
        empresa: empresa.empresa || "",
      });
    }
  }, [empresa]);

  const handleChange = (e) => {
    setFormValues({
      ...formValues,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const resp = await modifEmpresa(empresa._id, formValues);
      console.log("✅ Empresa actualizada:", resp);

      setShowSuccess(true); // Mostrar modal de éxito

      setTimeout(() => {
        setShowSuccess(false); // Ocultar mensaje
        handleClose();         // Cerrar modal principal
      }, 2000);
    } catch (error) {
      console.error("❌ Error al actualizar empresa:", error);
      // Acá podrías mostrar un modal de error
    }
  };


  // const [localidades, setLocalidades] = useState({ data: {}, loading: true });
  // const [rutas, setRutas] = useState({ data: {}, loading: true });

  // useEffect(() => {
  //   getLocalidades().then((res) =>
  //     setLocalidades({ data: res, loading: false })
  //   );
  //   getRutas().then((res) => setRutas({ data: res, loading: false }));
  // }, []);

  return (
    <>
    <Modal show={show} onHide={handleClose}>
      <form onSubmit={handleSubmit}>
        <Modal.Header closeButton>
          <Modal.Title>Modificar Empresa</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <div className="form-group mt-2">
            <label>Empresa</label>
            <input
              type="text"
              className="form-control"
              name="empresa"
              required
              value={formValues.empresa}
              onChange={handleChange}
            />
          </div>

        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Cancelar
          </Button>
          <Button type="submit" variant="dark">
            Guardar
          </Button>
        </Modal.Footer>
      </form>
    </Modal>

    <Modal
      show={showSuccess}
      centered
      backdrop="static"
      keyboard={false}
      dialogClassName="animate__animated animate__fadeInDown"
    >
      <Modal.Body className="text-center">
        <div style={{ fontSize: "3rem" }}>🖐</div>
        <h5 className="mt-2">¡Cambios guardados correctamente!</h5>
      </Modal.Body>
    </Modal>
    </>

  );
};

export default ModalFormEmpresa;
